import type { AxiosRequestConfig } from "axios";
import merge from "lodash.merge";
import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import type { RootState } from "@/store/store";
import {
  fetchDocumentCategoriesAsync,
  fetchDocumentsAsync,
} from "./documentsApi";
import { documentSelectors } from "./documentsSlice";

type FetchDocumentsArgs = {
  estateId: number;
  options?: AxiosRequestConfig;
};
export const fetchDocumentsThunk = createAppAsyncThunk(
  "documents/fetchDocuments",
  async (args: FetchDocumentsArgs, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const textSearch = documentSelectors.selectTextSearch(state);
    // add estateId to options
    const defaultOptions: AxiosRequestConfig = {
      params: {
        filter: {
          estateId: args.estateId,
          fulltext: textSearch ? textSearch : "",
        },
      },
    };
    const mergedOptions = merge(defaultOptions, args.options);
    const response = await fetchDocumentsAsync(mergedOptions);
    const documents = response.data;

    return documents;
  },
);

export const fetchDocumentCategoriesThunk = createAppAsyncThunk(
  "documents/fetchCategories",
  async (options: AxiosRequestConfig | undefined) => {
    const response = await fetchDocumentCategoriesAsync(options);
    return response.data;
  },
);

// Derive Document type from API response
export type Document = Awaited<
  ReturnType<typeof fetchDocumentsAsync>
>["data"][number];

// Derive DocumentCategory type from API response
export type DocumentCategory = Awaited<
  ReturnType<typeof fetchDocumentCategoriesAsync>
>["data"][number];
